import { axiosInstance } from "@/api";

export interface TikTokCreatorLinkStatus {
	linked: boolean;
	username: string | null;
	openId: string | null;
	accessTokenExpired: boolean;
	refreshTokenExpired: boolean;
	linkedAt: string | null;
}

export interface TikTokCreatorLinkResult {
	linked: boolean;
	username: string | null;
	openId: string;
}

export const tiktokCreatorLinkApi = {
	startLink: async (): Promise<{ state: string }> => {
		const response = await axiosInstance.post("/tiktok/creator/link/start");
		return response.data;
	},

	linkAccount: async (code: string, state: string): Promise<TikTokCreatorLinkResult> => {
		const response = await axiosInstance.post("/tiktok/creator/link", { code, state });
		return response.data;
	},

	unlinkAccount: async (): Promise<{ unlinked: boolean }> => {
		const response = await axiosInstance.delete("/tiktok/creator/link");
		return response.data;
	},

	getStatus: async (): Promise<TikTokCreatorLinkStatus> => {
		const response = await axiosInstance.get("/tiktok/creator/status");
		return response.data;
	},
};
